/**
 * Card de captação do parceiro na home (25/09/2026).
 *
 * ── PARA QUE SERVE ──────────────────────────────────────────────────────────────────────────────
 *
 * A Nomos vai divulgar a nossa landing para a base deles. Quem chegar por essa divulgação precisa
 * de um caminho próprio — e esse caminho **não é o nosso checkout**: é o CRM deles. O card só
 * direciona; quem atende, qualifica e libera é o time da Nomos.
 *
 * Por isso o botão abre uma conversa no WhatsApp DELES, e não um formulário nosso. Se um dia isso
 * virar link de checkout automático (o projeto já tem link de parceiro com período de teste),
 * muda-se `DESTINO` e mais nada.
 *
 * ── A MENSAGEM JÁ VAI ESCRITA, E ISSO NÃO É DETALHE ─────────────────────────────────────────────
 *
 * O texto pré-preenchido serve a três coisas de uma vez: a pessoa não precisa pensar no que dizer
 * (o que derruba quem clica por impulso), quem atende já sabe do que se trata sem perguntar, e a
 * origem fica registrada na própria conversa — sem parâmetro de URL, sem rastreador, sem cookie.
 */
import { ArrowUpRight } from "lucide-react";

/**
 * Número do WhatsApp do parceiro, com DDI e DDD, só dígitos.
 *
 * ⚠️ É o número DELES (quem atende), não o nosso. Trocar aqui é suficiente: não há outra referência
 * no projeto.
 */
const WHATSAPP_PARCEIRO = "5521968850695";

/** O que já vai escrito na conversa quando a pessoa abre. */
const MENSAGEM = "Olá, Iuri!! Quero garantir o meu acesso aos 30 dias gratuitos + condição de founder, no Terminal HTS.";

const DESTINO = `https://wa.me/${WHATSAPP_PARCEIRO}?text=${encodeURIComponent(MENSAGEM)}`;

export function CardParceiro() {
  return (
    <div className="hts-parceiro">
      <div className="hts-parceiro-txt">
        <div className="hts-parceiro-eyebrow">
          Acesso antecipado
          {/* O logo do parceiro ao lado do selo, e não solto no meio do texto: aqui ele responde
              de imediato a pergunta "quem está oferecendo isso?", que é a primeira que passa na
              cabeça de quem lê uma oferta boa demais. */}
          <img src="/img/parceiros/nomos.png" alt="Nomos" className="hts-parceiro-logo" loading="lazy" decoding="async" />
        </div>
        <h3 className="hts-parceiro-title">
          Quer acesso antecipado <br />
          <span className="hts-parceiro-title-hl">+ 30 dias de teste?</span>
        </h3>
        <p className="hts-parceiro-desc">
          Quem chega por um dos nossos parceiros entra antes da ativação em ondas, ganha 30
          dias de teste e mantém a condição de founder — o preço travado por 12 meses. Fale no
          WhatsApp para garantir.
        </p>
      </div>

      <a
        className="hts-parceiro-cta"
        href={DESTINO}
        target="_blank"
        /* noopener: a aba que abre não pode ganhar referência à nossa janela. */
        rel="noopener noreferrer"
        data-cursor-hover
      >
        Falar no WhatsApp <ArrowUpRight size={18} />
      </a>
    </div>
  );
}
